export default "__VITE_ASSET__Dg4wf9LB__"